import { motion } from "framer-motion";

import commoncss from "../../../myfin_v2/css/common.module.css";
import buttoncss from "../../../myfin_v2/css/button.module.css";
import wsCreationcss from "../../../myfin_v2/css/workspaceCreation.module.css";
import bookclosurecss from "../../../myfin_v2/css/bookclosure.module.css";
import Modal from "../../../myfin_v2/elements/Modal";
import { Button } from "../../../myfin_v2/elements/Button";
import Dropdown from "../../../myfin_v2/elements/Dropdown";
import InputGroup from "../../../myfin_v2/elements/InputGroup";
import { ReactComponent as CloseIcon } from "../../../myfin_v2/assets/icons/close.svg";

import { useState, useEffect } from "react";

const TranslateFSModal = ({ handleClose,setShowTranslateFSModal }) => {
  const user = JSON.parse(localStorage.getItem("user"));
  const permissions = JSON.parse(localStorage.getItem("permission"));

  const natureOfCompanyList = [
    "Manufacturing",
    "NBFC",
    "Banking",
    "Trading",
    "Other Specify",
  ];

  const functionalCurrencyList = ["INR", "USD", "LKR", "AUD"];

  const [organizationName, setOrganizationName] = useState("");
  const [natureOfCompany, setNatureOfCompany] = useState("");
  const [funcationalCurrency, setFuncationalCurrency] = useState("");
  const [cinNo, setCINNo] = useState("");
  const [panTaxNo, setPANTaxNo] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [approver, setApprover] = useState("");

  return (
    <>
      <Modal
        title={"Preset Information"}
        width="50%"
        headerActions={
          <CloseIcon
          onClick={() => {
                setShowTranslateFSModal(false);
              }}
            className="clickable"
          />
        }
        footerActions={
          <>
            <Button
              btnColor={buttoncss.secondary}
              onClick={() => {
                setShowTranslateFSModal(false);
              }}
              label="Cancel"
            />
            <Button
              btnColor={buttoncss.primary}
              label="Submit"
              onClick={() => {
                setShowTranslateFSModal(false);
              }}
            />
          </>
        }
        onClose={() => console.log("Modal Closed")}
      >
        <div style={{ width: "95%", "place-self": "center" }}>
          <InputGroup
            inputs={[
              <>
                <InputGroup
                  label="Select Preset"
                  inputs={[
                    <>
                      <Dropdown
                        options={natureOfCompanyList.map((item, idx) => ({
                          label: item,
                          value: item,
                        }))}
                        onSelect={(sel) => {
                          setNatureOfCompany(sel.value);
                        }}
                        placeHolder="Select Preset"
                        selected={{ label: "", value: "" }}
                      />
                    </>,
                  ]}
                />
              </>,
              <>
                <InputGroup
                  label="Reporting Currency"
                  inputs={[
                    <>
                      <Dropdown
                        options={functionalCurrencyList.map((item, idx) => ({
                          label: item,
                          value: item,
                        }))}
                        onSelect={(sel) => setFuncationalCurrency(sel.value)}
                        placeHolder="Select Reporting Currency"
                        selected={{ label: "", value: "" }}
                      />
                    </>,
                  ]}
                />
              </>,
            ]}
          />

          <InputGroup
            inputs={[
              <>
                <InputGroup
                  label="Company"
                  inputs={[
                    <>
                      <input
                        type="text"
                        value={cinNo}
                        onChange={(e) => setCINNo(e.target.value)}
                        placeholder="Company"
                      />
                    </>,
                  ]}
                />
              </>,
              <>
                <InputGroup
                  label="Nature of Company"
                  inputs={[
                    <>
                      <Dropdown
                        options={natureOfCompanyList.map((item, idx) => ({
                          label: item,
                          value: item,
                        }))}
                        onSelect={(sel) => {
                          setNatureOfCompany(sel.value);
                        }}
                        placeHolder="Select Nature of Company"
                        selected={{ label: "", value: "" }}
                      />
                    </>,
                  ]}
                />
              </>,
            ]}
          />

          <InputGroup
            inputs={[
              <>
                <InputGroup
                  label="Name of the Financials"
                  inputs={[
                    <>
                      <input
                        type="text"
                        value={cinNo}
                        onChange={(e) => setCINNo(e.target.value)}
                        placeholder="Name of the Financials"
                      />
                    </>,
                  ]}
                />
              </>,
              <>
                <InputGroup
                  label="Select the GAAP"
                  inputs={[
                    <>
                      <Dropdown
                        options={natureOfCompanyList.map((item, idx) => ({
                          label: item,
                          value: item,
                        }))}
                        onSelect={(sel) => {
                          setNatureOfCompany(sel.value);
                        }}
                        placeHolder="Select the GAAP"
                        selected={{ label: "", value: "" }}
                      />
                    </>,
                  ]}
                />
              </>,
            ]}
          />

          
          <InputGroup
            inputs={[
              <>
                <InputGroup
                  label="Select presents/Chart of accounts"
                  inputs={[
                    <>
                      <Dropdown
                        options={natureOfCompanyList.map((item, idx) => ({
                          label: item,
                          value: item,
                        }))}
                        onSelect={(sel) => {
                          setNatureOfCompany(sel.value);
                        }}
                        placeHolder="Select presents/Chart of accounts"
                        selected={{ label: "", value: "" }}
                      />
                    </>,
                  ]}
                />
              </>,
              <>
                <InputGroup
                  label="Functional Currency"
                  inputs={[
                    <>
                      <Dropdown
                        options={functionalCurrencyList.map((item, idx) => ({
                          label: item,
                          value: item,
                        }))}
                        onSelect={(sel) => setFuncationalCurrency(sel.value)}
                        placeHolder="Select Functional Currency"
                        selected={{ label: "", value: "" }}
                      />
                    </>,
                  ]}
                />
              </>,
            ]}
          />
        </div>
      </Modal>
    </>
  );
};

export default TranslateFSModal;
